/* eslint-disable react/prop-types */
import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { PersonalDetailsView } from '../../details/personal-detail';
import { AddressDetailsView } from '../../details/address-details';
import { EmploymentDetailsView } from '../../details/employment-details';
import { FormDetails } from '../../form-details-reducer';
import { Nullable } from '../../../../../../shared-types';
import { ClaimType } from '../../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}

interface Props extends StyledComponent, BaseProps {}

const policyHolderDetailsView: React.FunctionComponent<Props> = ({
    formDetails,
    disableEditButton,
    claimType,
}) => {
    return (
        <ExpansionPanel name="Policyholder details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <PersonalDetailsView
                    type="Policyholder"
                    formDetails={formDetails}
                    disableEditButton={disableEditButton || false}
                />

                <AddressDetailsView
                    type="Policyholder"
                    formDetails={formDetails}
                    disableEditButton={disableEditButton || false}
                />
                {formDetails?.policyholder?.isThePolicyHolderAnIndividualOrCompany ===
                    'Individual' && (
                    <EmploymentDetailsView
                        formDetails={formDetails}
                        disableEditButton={disableEditButton || false}
                        claimType={claimType}
                    />
                )}
            </React.Fragment>
        </ExpansionPanel>
    );
};

export const PolicyHolderDetailsView = withStyles(styles)(policyHolderDetailsView);
